export default "__VITE_ASSET__68ee3300__"